import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import DatePicker from "react-multi-date-picker";
import moment from "moment-jalaali";
import "moment/locale/fa";
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import CrudFormModal from "../components/CrudFormModal";

const Article = () => {
    //#region const
    const navigate = useNavigate();
    const toaster = useToaster();
    const [SelectedCategory, SetSelectedCategory] = useState(General.GuidEmpty());
    const [Categories, setCategories] = useState([]);
    const [Articles, setArticles] = useState([]);
    const [ShowModal, setShowModal] = useState(false);
    const [Image, setImage] = useState();
    const [ImageName, setImageName] = useState("");
    const [PrevImageName, setPrevImageName] = useState("");
    const [Title, setTitle] = useState("");
    const [Summary, setSummary] = useState("");
    const [Content, setContent] = useState("");
    const [Author, setAuthor] = useState("");
    const [ArticleId, setArticleId] = useState(General.GuidEmpty());
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDay, setSelectedDay] = useState(moment());
    const [IsActive, setIsActive] = useState(true);
    const [Order, setOrder] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region Handler
    const ImageCheck = (e) => {
        setImage(e.target.files[0]);
        setImageName(e.target.files[0].name);
    }
    //#endregion
    //#region method
    const clearDependecies = () => {
        setArticleId(General.GuidEmpty());
        SetSelectedCategory(General.GuidEmpty());
        setTitle("");
        setSummary("");
        setContent("");
        setAuthor("");
        setImageName("");
        setPrevImageName("");
        setImage(null);
        setIsActive(true);
        setOrder(0);
        setSelectedDay(moment());
    }
    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/article/delete/' + ArticleId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetArticles();
                    setArticleId(General.GuidEmpty());
                    setShowDeleteModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetArticleById = (Id) => {
        setArticleId(Id);
        var RequestOption = {
            url: General.ApiRoot() + '/article/getById/' + Id,
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    const row = result.data && result.data[0];
                    if (row) {
                        setTitle(row.Title);
                        setSummary(row.Summary);
                        setContent(row.Content);
                        setAuthor(row.Author);
                        setPrevImageName(row.FileName);
                        SetSelectedCategory(row.CategoryId || General.GuidEmpty());
                        setIsActive(!!row.IsActive);
                        setOrder(row.Order);
                        if (row.PublishDate) {
                            setSelectedDay(moment(row.PublishDate, "jYYYY/jMM/jDD"));
                        }
                        setShowModal(true);
                    }
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategories = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/articleCategory/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setCategories(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetArticles = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/article/getAll',
            method: "get",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setArticles(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const AddNewArticle = () => {
        setShowModal(true);
    }
    const CheckValidation = () => {
        if (Title == "") {
            setErrorMsg('لطفا عنوان را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عنوان را وارد کنید'), 'topCenter');
            return false;
        }
        else if (Content == "") {
            setErrorMsg('لطفا متن مقاله را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا متن مقاله را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    }
    const Save = () => {
        if (CheckValidation()) {
            setErrorMsg("");
            const isNew = ArticleId === General.GuidEmpty();
            const formData = new FormData();
            formData.append('FormFile', Image ? Image : "");
            formData.append('FileName', ImageName ? ImageName : "");
            formData.append('Title', Title);
            formData.append('Summary', Summary);
            formData.append('Content', Content);
            formData.append('Author', Author);
            formData.append('Id', ArticleId);
            formData.append('PrevFileName', PrevImageName ? PrevImageName : "");
            formData.append('PublishDate', selectedDay.format("jYYYY/jMM/jDD"));
            formData.append('IsActive', IsActive ? 1 : 0);
            formData.append('CategoryId', SelectedCategory);
            formData.append('Order', Order);
            const requestOptions = {
                url: General.ApiRoot() + '/article/' + (isNew ? 'insert' : 'update'),
                method: "post",
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفق انجام شد'), 'topCenter');
                        GetArticles();
                        clearDependecies();
                        setShowModal(false);
                    }).catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    }
    //#endregion

    const columns = [
        {
            id: "index",
            header: () => <div className="text-right"> ردیف</div>,
            cell: ({ row }) => <div className="">{row.index + 1}</div>,
        },
        {
            id: "title",
            header: () => <div className="text-right">عنوان مقاله</div>,
            cell: ({ row }) => <div className="">{row.original.Title}</div>,
        },
        {
            id: "author",
            header: () => <div className="text-right">نویسنده</div>,
            cell: ({ row }) => <div className="">{row.original.Author}</div>,
        },
        {
            id: "isActive",
            header: () => <div className="text-right">وضعیت</div>,
            cell: ({ row }) => <div className="">{row.original.IsActive ? "منتشر شده" : "پیش‌نویس"}</div>,
        },
        {
            id: "order",
            header: () => <div className="text-right">ترتیب نمایش</div>,
            cell: ({ row }) => <div className="">{row.original.Order}</div>,
        },
        General.actionsColumn(GetArticleById, (id) => (setArticleId(id), setShowDeleteModal(true))),
    ];

    const table = useReactTable({
        data: Articles,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        if (!General.isLoggedIn()) {
            navigate('/');
        }
        else {
            GetCategories();
            GetArticles();
        }
    }, []);

    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="مقالات" onAdd={AddNewArticle} />
                <DataTable table={table} />
            </div>
            <CrudFormModal
                open={ShowModal}
                title="تعریف مقاله جدید"
                onClose={() => (setShowModal(false), clearDependecies())}
                onSave={Save}
            >
                <rsuite.Row>
                    <label>تاریخ انتشار</label>
                    <div className="mt-2">
                        <DatePicker
                            onChange={setSelectedDay}
                            value={selectedDay}
                            isGregorian={false}
                            timePicker={false}
                            className="w-full border rounded-md h-9"
                        />
                    </div>
                </rsuite.Row>
                <rsuite.Row className="mt-2">
                    <rsuite.Col xs={12}>
                        <label>دسته‌بندی</label>
                        <rsuite.InputPicker
                            data={Categories}
                            valueKey="Id"
                            labelKey="Title"
                            value={SelectedCategory}
                            onChange={(e) => SetSelectedCategory(e)}
                            block
                            placeholder='انتخاب کنید'
                            className="mt-1"
                        />
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <label>ترتیب نمایش</label>
                        <rsuite.InputNumber value={Order} onChange={e => setOrder(e)} className="mt-1" />
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row className="mt-3">
                    <rsuite.Col xs={12}>
                        <label>عنوان مقاله</label>
                        <rsuite.Input value={Title} onChange={e => setTitle(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <label>نویسنده</label>
                        <rsuite.Input value={Author} onChange={e => setAuthor(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row>
                    <rsuite.Col xs={24} className="mt-2">
                        <rsuite.Checkbox checked={IsActive} onChange={() => setIsActive(!IsActive)}>منتشر شود</rsuite.Checkbox>
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row className="mt-2">
                    <label>انتخاب عکس</label>
                    <rsuite.Input type="file" onInput={ImageCheck} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>خلاصه</label>
                    <rsuite.Input as="textarea" value={Summary} onChange={e => setSummary(e)} rows={2} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>متن کامل مقاله</label>
                    <rsuite.Input as="textarea" value={Content} onChange={e => setContent(e)} rows={6} className="mt-1 mb-3" />
                </rsuite.Row>
            </CrudFormModal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف مقاله مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setArticleId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}
export default Article;
